<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" @opened="openFun">
    <el-form :model="entity" :rules="rules" ref="flowRef" label-width="120px">
      <el-form-item v-show="false" prop="id">
        <el-input v-model="entity.id"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="entity.type" placeholder="请选择类型">
          <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件" prop="path">
        <el-upload
            class="upload-demo"
            action=""
            :show-file-list="false"
            :file-list="fileLList"
            :multiple="false"
            :limit="1"
            :http-request="e => upload(e)"
            accept=".pdf,.doc,.docx"
        >
          <el-button type="primary" :loading="uploading">点击上传</el-button>
        </el-upload>
        <el-link v-if="entity.path" type="primary" :href="entity.path" target="_blank">
          {{ entity.filename }}
        </el-link>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetForm('flowRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('flowRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {editTemplate, getTemplateList} from "@/api/template/template";
import {successMsg} from "@/utils/message";
import {upload} from "@/utils/oss";

export default {
  name: "editFlow",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    dataObj: Object
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '新增',
      isLoading: false,
      fileLList: [],
      typeList: [],
      entity: {
        id: null,
        type: '',
        path: '',
        filename: ''
      },
      rules: {
        type: [{required: true, message: '类型不能为空', trigger: 'change'}],
        path: [{required: true, message: '路径不能为空', trigger: 'blur'}]
      },
      uploading: false,
    }
  },
  methods: {
    resetForm(ref) {
      this.$refs[ref].resetFields()
    },
    openFun() {
      this.title = this.dataObj.id ? '编辑' : "新增";
      this.entity = this.dataObj ? this.dataObj : {};
      this.fileLList = []
      getTemplateList().then(res => {
        const hasTypeList = res.map(item => {
          return String(item.type)
        });
        this.typeList = this.$dict.map['template_type'].filter(item => {
          return !hasTypeList.includes(item.value) || item.value === this.entity.type
        })
      })
    },
    //  提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          editTemplate(this.entity).then(() => { // 修改API调用
            successMsg('操作成功')
            this.visible = false
            this.$emit('get-list')
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    },
    beforeUpload(file) {
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      const isAllowedType = allowedTypes.includes(file.type);

      if (!isAllowedType) {
        this.$message.error('上传文件只能是 PDF、DOC 或 DOCX 格式!');
        return false;
      }

      const isLt500K = file.size / 1024 < 500;

      if (!isLt500K) {
        this.$message.error('上传头像图片大小不能超过 500KB!');
      }
      return isAllowedType && isLt500K;
    },
    upload(e) {
      if (!e) {
        return
      }
      const file = e.file
      if (!file || !file.name) {
        return
      }
      this.entity.filename = file.name
      this.uploading = true;
      upload(file,"template",true)
          .then(url => {
            this.$message.success('上传成功')
            this.entity.path = url
            this.$forceUpdate()
            this.uploading = false;
          })
          .catch(err => {
            this.$message.error('上传失败：' + err)
            this.uploading = false;
          })
    }
  }
}
</script>

<style scoped>
::v-deep .vue-treeselect__control {
  height: 28px;
}

::v-deep .el-form-item__content {
  line-height: 28px;
  font-size: 12px;
}
</style>
